<template>
  <v-btn-toggle id="show-cash-button" :value="showCash" mandatory>
    <v-btn
      small
      color="softBackgroundGrey"
      :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }"
      :value="true"
      @click="showCashChanged(true)"
    >
      {{ $t('views.common.showCashButton.withCash') }}
    </v-btn>
    <v-btn
      small
      color="softBackgroundGrey"
      :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }"
      :value="false"
      @click="showCashChanged(false)"
    >
      {{ $t('views.common.showCashButton.withoutCash') }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  props: {
    showCash: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showCashChanged(showCash) {
      this.$emit('showCashChanged', showCash)
    },
  },
}
</script>

<style lang="scss">
#show-cash-button {
  .v-btn__content {
    text-transform: none;
  }
}
</style>
